import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { InputField, ErrorMessage } from 'anf-core-react';
import formatExpiry from './helpers/formatExpiry';

function ExpiryField({
  label,
  errorMessage,
  expiryDate,
  index,
  onChange,
  hasValidationError,
}) {
  const [localExpiry, setLocalExpiry] = useState(expiryDate || '');
  const [isValid, setIsValid] = useState(true);
  const id = `expiryDate_${index}`;

  useEffect(() => {
    setLocalExpiry(expiryDate || '');
  }, [expiryDate]);

  const handleChange = (e) => {
    const formatted = formatExpiry(e.target.value);
    setLocalExpiry(formatted);
    onChange(formatted);
  };

  const handleBlur = () => {
    // Basic validation: MM / YY format (with spaces) and not expired
    const valid = /^\d{2} \/ \d{2}$/.test(localExpiry);
    if (valid) {
      const [month, year] = localExpiry.split(' / ');
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear() % 100;
      const currentMonth = currentDate.getMonth() + 1;

      const expMonth = parseInt(month, 10);
      const expYear = parseInt(year, 10);

      // Validate that the year is reasonable (within next 10 years)
      const maxValidYear = currentYear + 10;
      const isValidDate = expMonth >= 1 && expMonth <= 12
                         && expYear <= maxValidYear
                         // eslint-disable-next-line max-len
                         && (expYear > currentYear || (expYear === currentYear && expMonth >= currentMonth));
      setIsValid(isValidDate);
    } else {
      setIsValid(false);
    }
  };

  const showError = hasValidationError || !isValid;

  return (
    <div className="expiry-field">
      <InputField
        id={id}
        name={id}
        value={localExpiry}
        onChange={handleChange}
        onBlur={handleBlur}
        type="text"
        maxLength={5}
        placeholder="MM/YY"
        label={label}
        autoComplete="cc-exp"
        isInvalid={showError}
        aria-invalid={showError}
      >
        {showError && errorMessage && (
          <ErrorMessage>
            {errorMessage}
          </ErrorMessage>
        )}
      </InputField>
    </div>
  );
}

ExpiryField.propTypes = {
  label: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  expiryDate: PropTypes.string,
  index: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  hasValidationError: PropTypes.bool,
};

ExpiryField.defaultProps = {
  errorMessage: '',
  expiryDate: '',
  index: 0,
  hasValidationError: false,
};

export default ExpiryField;
